const isProduction = process.env.NEXT_PUBLIC_PORTAL_URL === 'https://app.hcidoculink.net'
export const ENV_HELPERS = {
  apiUrl: process.env.NEXT_PUBLIC_API_URL,
  API_URL: process.env.NEXT_PUBLIC_API_URL || '',
  APIKEY: process.env.NEXT_PUBLIC_APIKEY || '',
  AUTHDOMAIN: process.env.NEXT_PUBLIC_AUTHDOMAIN || '',
  DATABASEURL: process.env.NEXT_PUBLIC_DATABASEURL || '',
  PROJECTID: process.env.NEXT_PUBLIC_PROJECTID || '',
  STORAGEBUCKET: process.env.NEXT_PUBLIC_STORAGEBUCKET || '',
  MESSAGINGSENDERID: process.env.NEXT_PUBLIC_MESSAGINGSENDERID || '',
  APPID: process.env.NEXT_PUBLIC_APPID || '',
  S3_IMAGE_DOMAIN: process.env.S3_IMAGE_DOMAIN || '',
  IDEAROOM_IMAGE_DOMAIN: process.env.IDEAROOM_IMAGE_DOMAIN || '',
  PORTAL_URL: process.env.NEXT_PUBLIC_PORTAL_URL || '',
  MATIC_MERCHANT_ID: process.env.NEXT_PUBLIC_MATIC_MERCHANT_ID || '',
  MATIC_GATEWAY_ID: process.env.NEXT_PUBLIC_MATIC_GATEWAY_ID || '',
  MATIC_SDK_KEY: process.env.NEXT_PUBLIC_MATIC_SDK_KEY || '',
  MATIC_SANDBOX_MODE: process.env.NEXT_PUBLIC_MATIC_SANDBOX_MODE === '1',
  SMARTY_STREET_KEY: isProduction ? process.env.NEXT_PUBLIC_SMARTY_KEY || '' : '197010229200251399',
  AUTOCOMPLETE_URL: process.env.NEXT_PUBLIC_AUTOCOMPLETE_URL || '',
  COMPOSE_FILE: process.env.COMPOSE_FILE || '',
  COMPOSE_PROJECT_NAME: process.env.COMPOSE_PROJECT_NAME || '',
  APP_ENV: process.env.APP_ENV || 'development',
  NODE_ENV: process.env.NODE_ENV || 'development',
  TARGET_ENV: process.env.TARGET_ENV || 'development',
  APP_URL: process.env.APP_URL || 'http://localhost:3070',
  APP_PORT: Number(process.env.APP_PORT) || 3070,
  SMARTY_API_AUTH_ID: process.env.NEXT_PUBLIC_SMARTY_API_AUTH_ID || '',
  SMARTY_API_AUTH_TOKEN: process.env.NEXT_PUBLIC_SMARTY_API_AUTH_TOKEN || '',
}

export const PLACEHOLDERS = {
  email: 'email@email.com',
  phoneNumber: '634-545-5432',
  url: 'https://website.com',
}

export const REGEX_EXPRESSIONS = {
  validName: /^[a-zà-ÿA-ZÀ-ÿ](?!.*[ ']{2})[ a-zA-Z']+$/,
  validURL: /http(s)?:\/\/?[(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/,
  validPhone: /^\d{3}-\d{3}-\d{4}$/,
  validPassword: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%&*]).{6,16}$/,
}
